import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface FieldFilter {
  search?: string;   // filtro testuale (di solito su name)
  system?: boolean;  // opzionale
  type?: string;     // tipologia
}

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  private readonly http = inject(HttpClient);

  /**
   * GET /field/list (paginata)
   */
  getMetaList(
    pageIndex: number,
    pageSize: number,
    sortBy: string,
    fieldFilter: string | FieldFilter
  ): Observable<any> {
    let params = new HttpParams()
      .set('pageIndex', pageIndex)
      .set('pageSize', pageSize)
      .set('sortBy', sortBy);

    // Normalizza
    let search = '';
    let type: string | undefined;
    let system: boolean | undefined;

    if (typeof fieldFilter === 'string') {
      search = (fieldFilter ?? '').trim();
    } else if (fieldFilter && typeof fieldFilter === 'object') {
      if (typeof fieldFilter.search === 'string') search = fieldFilter.search.trim();
      if (typeof fieldFilter.type === 'string')   type   = fieldFilter.type.trim();
      if (typeof fieldFilter.system === 'boolean') system = fieldFilter.system;
    }

    // Parametri flat
    if (search) params = params.set('search', search);
    if (type)   params = params.set('type', type);
    if (typeof system === 'boolean') params = params.set('system', String(system));

    return this.http.get<any>(`${environment.api.host_path}/field/list`, { params });
  }

  getAllfieldTypes() {
    return this.http.get(`${environment.api.host_path}/field-type/listAll`);
  }

  addNewField(params: any) {
    return this.http.post(`${environment.api.host_path}/field`, params);
  }

  editField(params: any) {
    return this.http.put(`${environment.api.host_path}/field`, params);
  }

  deleteField(id: number) {
    return this.http.delete(`${environment.api.host_path}/field/${id}`);
  }
}
